import { render, staticRenderFns } from "./SelectMultipleSearch.vue?vue&type=template&id=60d65c48&"
import script from "./SelectMultipleSearch.vue?vue&type=script&lang=js&"
export * from "./SelectMultipleSearch.vue?vue&type=script&lang=js&"
import style0 from "./SelectMultipleSearch.vue?vue&type=style&index=0&id=60d65c48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports